import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';


import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaPlus, FaImages, FaEye } from 'react-icons/fa';
import { getEvents } from '../services/api';

const PhotographerDashboard = () => {

  console.log('PhotographerDashboard rendered'); // Debugging log
  
  const { user } = useAuth();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await getEvents();
      setEvents(response.events);
    } catch (err) {
      setError(err.message || 'Failed to load events');
    } finally {
      setLoading(false);
    }
  };

  const getVisibilityBadge = (visibility) => {
    const colors = {
      public: '#4CAF50',
      unlisted: '#FF8C42',
      private: '#9C27B0'
    };
    
    return (
      <span style={{
        background: colors[visibility] || colors.public,
        color: 'white',
        padding: '0.3rem 0.8rem',
        borderRadius: '15px',
        fontSize: '0.8rem',
        fontWeight: '600',
        marginLeft: '0.5rem'
      }}>
        {visibility ? visibility.toUpperCase() : 'PUBLIC'}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '4rem' }}>
        <div className="spinner"></div>
        <p>Loading your events...</p>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="dashboard-header">
        <h1>My Photography Events</h1>
        <p>Manage your events and photo uploads</p>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to="/create-event" className="btn-primary">
          <FaPlus /> Create New Event
        </Link>
        {user?.subscription_plan && (
          <div style={{
            padding: '0.8rem 1.5rem',
            background: 'var(--off-white)',
            borderRadius: '8px',
            fontSize: '0.9rem'
          }}>
            <strong>Plan:</strong> {user.subscription_plan.charAt(0).toUpperCase() + user.subscription_plan.slice(1)} • 
            <strong> Events:</strong> {events.length} / {user.event_limit === -1 ? '∞' : user.event_limit}
          </div>
        )}
      </div>

      {events.length === 0 ? (
        <div style={{ 
          padding: '3rem', 
          textAlign: 'center', 
          background: 'var(--white)', 
          borderRadius: '15px',
          boxShadow: '0 4px 8px var(--shadow)'
        }}>
          <FaCalendarAlt style={{ fontSize: '4rem', color: 'var(--gray)', marginBottom: '1rem' }} />
          <h3 style={{ color: 'var(--dark-gray)', marginBottom: '1rem' }}>
            No Events Yet
          </h3>
          <p style={{ color: 'var(--gray)', marginBottom: '2rem' }}>
            Create your first event to start uploading and organizing photos
          </p>
          <Link to="/create-event" className="btn-primary">
            Create Your First Event
          </Link>
        </div>
      ) : (
        <div className="events-list">
          {events.map((event) => (
            <div key={event.id} className="event-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '1rem' }}>
                <h3>{event.name}</h3>
                {getVisibilityBadge(event.visibility)}
              </div>
              <div style={{ marginTop: '0.5rem' }}>
                <span className="category-badge">{event.category}</span>
              </div>
              <p style={{ color: 'var(--gray)', marginTop: '1rem' }}>
                {event.description || 'No description'}
              </p>
              <div style={{ 
                marginTop: '1rem', 
                paddingTop: '1rem', 
                borderTop: '1px solid var(--light-gray)',
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '0.9rem',
                color: 'var(--gray)'
              }}>
                <span>📸 {event.photo_count} photos</span>
                {event.event_date && (
                  <span>📅 {new Date(event.event_date).toLocaleDateString()}</span>
                )}
              </div>
              
              <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
                <Link
                  to={`/event/${event.id}/photos`}
                  style={{
                    flex: 1,
                    padding: '0.8rem',
                    background: 'var(--primary-orange)',
                    color: 'white',
                    textAlign: 'center',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: '600'
                  }}
                >
                  <FaImages /> Upload Photos
                </Link>
                <Link
                  to={`/event/${event.id}/browse`}
                  style={{
                    flex: 1,
                    padding: '0.8rem',
                    background: 'var(--primary-green)',
                    color: 'white',
                    textAlign: 'center',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: '600'
                  }}
                >
                  <FaEye /> Browse Photos
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PhotographerDashboard;
